import React from "react";
import { Check, Delete } from "baseui/icon";

export default (props: any) => {
	const cellValue = props.value;

	return <span>{cellValue == true ? <Check /> : cellValue == false ? <Delete /> : ""}</span>;
};
